import { useContext } from 'react';
import { Page } from 'components';
import { Filters, Results } from './components';
import { usersContext } from './UsersContext';



let Users = () => {
    let { user, isLoading } = useContext(usersContext);

    return (
        <Page
            useHeader={true}
            title="Users"
            isLoading={isLoading}
            addNewUrl={user?.cognitoStatus === "NotFound" ? '/user/addnew' : undefined}
        >
            <Filters />
            <Results />
        </Page>
    );
}

export default Users;